import React from 'react';

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}

export const ButtonPrimary: React.FC<Props> = ({children, onClick, className, disabled}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`w-fit text-white font-bold flex items-center gap-2 px-8 py-3 rounded-full bg-deepblue shadow-2xl hover:scale-105 transition-all ease-in-out cursor-pointer whitespace-nowrap pointer-events-auto ${className}`}
    >
      {children}
    </button>
  );
};
